import { render, staticRenderFns } from "./ModeloDocumentoListagemBotoesAcoes.vue?vue&type=template&id=6fdf9ecc&scoped=true"
import script from "./ModeloDocumentoListagemBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./ModeloDocumentoListagemBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdf9ecc",
  null
  
)

export default component.exports